import i18n from "i18next";
import k from "src/i18n/keys";

import React from "react";

import { useSelector } from "react-redux";
import { getCurrentUser } from "src/reducers";

import User from "src/components/user/Photo";
import NameOrEmail from "src/containers/user/NameOrEmail";
import ChatTimestamp from "src/components/messages/Chat/ChatTimestamp";
import MessageCard from "src/components/messages/Chat/MessageCard";
import SuggestionState from "./SuggestionState";

import {
  ChatCard,
  UserInfo,
  MessageHeader,
  NotificationNameOrEmail,
} from "src/components/messages/Chat/styles";
import {
  ChecklistNotification,
  FieldName,
  NotificationHeaderTitle,
} from "src/components/messages/Chat/Notification/styles";
import { AiSuggestionState } from "src/constants/ai";

import { SuggestionText } from "./styles";

import type { Message, RoomId } from "src/types";
import type { AiNotificationData } from "src/ts-types";

type Props = {
  message: Message;
  roomId: RoomId;
};

const Suggestion = ({ message, roomId }: Props) => {
  const { id, timestamp, author, data, delivered, read } = message;
  if (typeof data !== "object") {
    return null;
  }
  const { state: currentState, sourceField: field } =
    data as AiNotificationData;

  const currentUser = useSelector(({ app }) => getCurrentUser(app));

  return (
    <ChecklistNotification>
      <ChatCard first>
        <UserInfo>
          <User uid={author} size="sm" shape="ellipse" />
        </UserInfo>
        <MessageCard first isChecklistNotification>
          <MessageHeader>
            <NotificationHeaderTitle>
              {currentUser === author ? (
                <NotificationNameOrEmail>
                  {i18n.t(k.YOU)}
                </NotificationNameOrEmail>
              ) : (
                <NameOrEmail
                  uid={author}
                  showPending={false}
                  notificationVariant="key"
                />
              )}
              <SuggestionText>
                {" "}
                asked AI suggestion for{" "}
                <FieldName>
                  {" "}
                  {currentState === AiSuggestionState.Error
                    ? data?.label
                    : field?.label}
                </FieldName>
              </SuggestionText>
            </NotificationHeaderTitle>
            <ChatTimestamp
              timestamp={timestamp}
              delivered={delivered}
              read={read}
            />
          </MessageHeader>
          <SuggestionState
            currentState={currentState}
            data={data}
            messageId={id}
            roomId={roomId}
          />
        </MessageCard>
      </ChatCard>
    </ChecklistNotification>
  );
};

export default Suggestion;
